import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useConfigStore, useUIStore } from '@/store';
import { MainLayout, Modal } from '@/components';
import { RouteGrid } from '@/features/routes';
import { ConfigPanel } from '@/features/config';
import type { FontSize } from '@/types';

// Map fontSize to CSS class names (ensures type safety and explicit class names)
const FONT_SIZE_CLASS_MAP: Record<FontSize, string> = {
  normal: 'font-normal',
  large: 'font-large',
  larger: 'font-larger',
};

function App() {
  const { i18n } = useTranslation();
  const { locale, fontSize } = useConfigStore();
  const { isEditing, setIsEditing } = useUIStore();

  // Sync i18n language with config store
  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]); // Only depend on locale, i18n.changeLanguage is stable

  return (
    <div className={`h-full ${FONT_SIZE_CLASS_MAP[fontSize]}`}>
      <MainLayout>
        <RouteGrid />
      </MainLayout>

      <Modal isOpen={isEditing} onClose={() => setIsEditing(false)}>
        <ConfigPanel />
      </Modal>
    </div>
  );
}

export default App;
